import { Entity } from '../../../shared/models/enums/entity.enum';

export const MessagesCenterQueuesAlias = {
  [Entity.MESSAGES]: 'messages_center.individual_messages',
  [Entity.FILES]: 'messages_center.files',
  [Entity.BULKS]: 'messages_center.bulks',
  [Entity.BATCHES]: 'messages_center.batches'
};
